import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { AddressSelect } from '../AddressSelect'

import { getValidValue } from './AddressSelectFormikField.utils'

function AddressSelectFormikField({ Select = AddressSelect, ...restProps }) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
      getValidValue={getValidValue}
    />
  )
}

export default AddressSelectFormikField
